import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { onTabVisibilityChanged } from '~/features/app/actions';
import { triggerDataFetcher } from '~/features/base/actions/ui/dataFetcherActions';

const TabVisibilitySensor = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const handleVisibilityChange = () => {
            const isVisible = !document.hidden;
            dispatch(onTabVisibilityChanged(isVisible));
            if (isVisible) {
                dispatch(triggerDataFetcher());
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [dispatch]);

    return null;
};

export default TabVisibilitySensor;
